export const GET_REGION_NO_SUCCESS = 'GET_REGION_NO_SUCCESS';
export const DUMMY_MUTATION = 'DUMMY_MUTATION';
export const LOADING_MESSAGE = '正在获取区号列表...';
export const SET_IS_MOBILE_REQUEST_STATUS = 'SET_IS_MOBILE_REQUEST_STATUS';
export const SET_IS_MOBILE_CHECK_EXIST_REQUEST_STATUS = 'SET_IS_MOBILE_CHECK_EXIST_REQUEST_STATUS';
